<template>
  <div
    class="tw-w-full tw-flex tw-flex-col tw-items-center tw-text-center tw-text-sm"
  >
    <span>
      {{ $t('login_disclaimer') }}
      <br />
      <i18n-t keypath="terms_disclaimer">
        <template #terms>
          <a class="tw-link" href="#" @click.prevent="openTermsModal">{{
            $t('terms')
          }}</a>
        </template>
        <template #privacy>
          <a class="tw-link" href="#" @click.prevent="openPrivacyModal">{{
            $t('privacy')
          }}</a>
        </template>
      </i18n-t>
    </span>
  </div>

  <teleport to="body">
    <base-modal
      :show="isModalOpen"
      :heading="$t(agreementHeadline)"
      has-close-btn
      @close:modal="hideModal(false)"
    >
      <agreement-form modal :agreement-type="agreementType" />
    </base-modal>
  </teleport>
</template>

<script>
import { PRIVACY_ROUTE, TERMS_ROUTE } from '@config/routeNames.js'
import { defineAsyncComponent, ref, computed } from 'vue'
import { useModal } from '@composables'
import {
  AGREEMENT_TYPE_PRIVACY,
  AGREEMENT_TYPE_OPTIONS,
  AGREEMENT_TYPE_TOU,
} from '@config/options.js'
export default {
  components: {
    AgreementForm: defineAsyncComponent(() =>
      import('@components/Agreement/AgreementForm.vue')
    ),
  },
  setup() {
    const agreementType = ref(null)
    const { triggerModal, isModalOpen, hideModal } = useModal()

    const agreementHeadline = computed(
      () =>
        AGREEMENT_TYPE_OPTIONS.find(
          (t) => t.value === agreementType.value
        )?.short?.toLowerCase() || 'terms'
    )

    function openTermsModal() {
      triggerModal()
      agreementType.value = AGREEMENT_TYPE_TOU
    }

    function openPrivacyModal() {
      triggerModal()
      agreementType.value = AGREEMENT_TYPE_PRIVACY
    }

    return {
      agreementHeadline,
      openPrivacyModal,
      openTermsModal,
      agreementType,
      PRIVACY_ROUTE,
      isModalOpen,
      TERMS_ROUTE,
      hideModal,
    }
  },
}
</script>
